// ========================================================
// Dynamic Option Selector
// ========================================================
(function () {

    // Only run if Option Selector exists
    if (!$(".option-box").length) {
        return;
    }

    const comboSelection = {};
    const comboVariants = [];

    // ========================================================
    // Cache Variants
    // ========================================================

    const $productSelect = $("#ProductSelect-product-template");
    const $masterList = $(".option-selector-product-master").first();

    if ($masterList.length) {
        $masterList.find("option").each(function () {
            const $masterOption = $(this);
            const variantId = String($masterOption.val());

            $productSelect.find("option").filter(function () {
                return String(this.value) === variantId;
            }).remove();

            const $option = $masterOption.clone();
            $productSelect.append($option);

            comboVariants.push({
                element: $option[0],
                title: String($option.attr("data-title") || "").toLowerCase(),
                variantId: variantId,
                disabled: $option.prop("disabled"),
                modelValue: String($option.attr("data-model-value") || ""),
                colorValue: String($option.attr("data-color-value") || "").toLowerCase(),
                productTitle: String($option.attr("data-product-title") || "")
            });
        });
    } else {
        $productSelect.find("option").each(function () {
            const $option = $(this);

            comboVariants.push({
                element: this,
                title: ($option.data("title") || "").toLowerCase(),
                variantId: $option.val(),
                disabled: this.disabled
            });
        });
    }

    // ========================================================
    // Initial Selections
    // ========================================================

    $(".option-box.initial").each(function () {

        comboSelection[$(this).data("group")] = $(this).data("match-value") || $(this).data("value");

    });

    function syncModelColors(modelValue) {
        const $modelColors = $(".option-box.color-box[data-model-value]");

        if (!$modelColors.length) return;

        const selectedModel = String(modelValue || "");
        $modelColors.each(function () {
            const $color = $(this);
            if (String($color.data("model-value")) === selectedModel) {
                $color.removeClass("hide");
            } else {
                $color.addClass("hide");
            }
        });

        const $activeForModel = $modelColors.filter(function () {
            return String($(this).data("model-value")) === selectedModel;
        });

        let $selectedColor = $activeForModel.filter(".initial").first();
        if (!$selectedColor.length) $selectedColor = $activeForModel.first();

        if ($selectedColor.length) {
            $modelColors.removeClass("active");
            $selectedColor.addClass("active");
            comboSelection[$selectedColor.data("group")] = $selectedColor.data("match-value") || $selectedColor.data("value");
            $selectedColor.closest(".product-selector-wrapper")
                .find(".initial-group").text($selectedColor.data("display"));
        }
    }

    // ========================================================
    // Click
    // ========================================================

    $(document).on("click", ".option-box:not(.addon-selector-group .option-box)", function () {

        const $this = $(this);

        $this
            .closest(".select-wrapper")
            .find(".option-box")
            .removeClass("active");

        $this.addClass("active");

        comboSelection[$this.data("group")] = $this.data("match-value") || $this.data("value");

        $this.closest(".product-selector-wrapper")
            .find(".initial-group").text($this.data("display"));

        if (String($this.data("group")) === "model") {
            syncModelColors($this.data("value"));
        }

        //console.log("Current Selection", comboSelection);

        findComboVariant();

    });

    // ========================================================
    // Find Variant
    // ========================================================

    function findComboVariant() {

        for (const variant of comboVariants) {

            if (variant.modelValue && comboSelection.model && variant.modelValue !== String(comboSelection.model)) continue;
            if (variant.colorValue && comboSelection.color && variant.colorValue !== String(comboSelection.color).toLowerCase()) continue;

            let found = true;

            $.each(comboSelection, function (group, value) {

                if (!variant.title.includes(String(value).toLowerCase())) {
                    found = false;
                    return false;
                }

            });

            if (found) {
                applyVariant(variant.element);
                updateAddonTopup();
                updateColourAvailability();
                return;
            }

        }
        updateColourAvailability();
        //console.warn("No matching variant.");

    }
    // ========================================================
    // Update Colour Availability
    // ========================================================
    function updateColourAvailability() {
    $(".option-box.color-box")
        .not(".addon-selector-group .option-box.color-box")
        .each(function () {
        const $colour = $(this);
        const colorGroup = String($colour.data("group"));
        const candidateColor = String(
            $colour.data("match-value") || $colour.data("value") || ""
        ).toLowerCase();
        const selectedModel = String(comboSelection.model || "").toLowerCase();

        const available = comboVariants.some((variant) => {
            if (variant.disabled) return false;

            // Use the structured model value when the master-list option has one.
            if (
            variant.modelValue &&
            selectedModel &&
            variant.modelValue.toLowerCase() !== selectedModel
            ) {
            return false;
            }

            // Use the structured colour value when available.
            if (
            variant.colorValue &&
            variant.colorValue !== candidateColor
            ) {
            return false;
            }

            // Check any remaining groups against the title as before.
            return Object.entries(comboSelection).every(([group, value]) => {
            if (group === "model" && variant.modelValue) return true;
            if (group === colorGroup && variant.colorValue) return true;

            const requiredValue =
                group === colorGroup ? candidateColor : String(value).toLowerCase();

            return variant.title.includes(requiredValue);
            });
        });

        $colour.toggleClass("disabled", !available);
        });
    }
    // ========================================================
    // Update Active Thumbnail
    // ========================================================

    function updateActiveThumbnail(name) {
        $(".product-single__thumbnails-items")
            .removeClass(" active");

        $(".product-single__thumbnails-items." + name)
            .addClass(" active");

        $(".product-single__thumbnails-items a")
            .removeClass("active-thumb");

        $(".product-single__thumbnails-items." + name + " a")
            .addClass("active-thumb");

    }
    
    // ========================================================
    // Apply Variant
    // ========================================================

    function applyVariant(option) {

        const $option = $(option);

        const handle = String($option.data("handle-title") || $option.data("title"))
            .toLowerCase()
            .replace(/\s+\+\s+/g, "-")
            .replace(/\s+/g, "-");
        console.log("Generated Handle:", handle);
        $("#ProductSelect-product-template")
            .val($option.val())
            .trigger("change");

        $("#currentSelection")
            .attr("data-price", String($option.data("price")).replace(",", "").replace(".00", ""))
            .attr("data-compare", String($option.data("compare-price")).replace("$", "").replace(",", ""))
            .attr("data-main-variant", $option.val()) 
            .attr("data-variant", $option.val())
            //.attr("data-image", $option.data("image"))
            .attr("data-handle", handle)
            .attr("data-color", handle)
            .attr("data-restock", $option.data("restock"))
            .attr("data-voucher", $option.data("variant-voucher"))
            .attr("data-stocknum", $option.data("stockindicatornum"));

        // ----------------------------------------------------
        const selectedPrice = String($option.data("price") || "").replace(/,/g, "").replace(/\.00$/, "");
        if ($option.attr("data-model-value") && selectedPrice) {
            $("#ProductPrice-product-template").text("$" + selectedPrice);
        }

        const selectedAltTitle = String($option.attr("data-alt-title") || $option.attr("data-model-value") || "").trim();
        if (selectedAltTitle) {
            $(".product-single__title .main").text(selectedAltTitle);
        }

        // Thumbnail Mapping
        // ----------------------------------------------------

        let thumb = "";

        $.each(comboSelection, function (group) {

            const mappedThumb = $('.option-box.active[data-group="' + group + '"]')
                .data("thumb");

            if (mappedThumb) {
                thumb = mappedThumb;
            }

        });
        
        updateActiveThumbnail((thumb || handle).replace(/\//g, "-"));

        // ----------------------------------------------------
        // Update browser URL
        // ----------------------------------------------------

        const url = new URL(window.location.href);

        url.searchParams.set("variant", $option.val());

        window.history.replaceState({}, "", url.toString());

        updatePrice();
        updateThumbnail();
        updateLinks();
        updateStockIndicator();

    }

    // ========================================================
    // Initial Load
    // ========================================================

    syncModelColors(comboSelection.model);
    findComboVariant();

})();
// ========================================================
// Dynamic Option Selector End
// ========================================================


// ========================================================
// Dynamic Option Selector Addons
// ========================================================
(function () {

    // ----------------------------------------------------
    // Guard
    // ----------------------------------------------------

    if (!$(".option-selector-addon").length) {
        return;
    }

    
    const addonSelection = {};

    // ----------------------------------------------------
    // Initial Selection
    // ----------------------------------------------------

    $(".option-selector-addon .option-box.initial").each(function () {

        addonSelection[$(this).data("group")] = $(this).data("value");

    });
    updateAddonColourAvailability();

    // ----------------------------------------------------
    // Click
    // ----------------------------------------------------
    $(document).on("click", ".option-selector-addon .addon-box-option", function (e) {

        if ($(e.target).closest(".option-box").length) {
            return;
        }

        const $box = $(this);

        $box.toggleClass("active");

        if ($box.hasClass("active")) {
            findAddonVariant();
            $(".addon_by_variants-container").removeClass("hide");
        } else {
            $("#ProdBundle").removeAttr("data-gp2-id");
            $(".selectedgroupsell-addon").text("");
            $(".addon_by_variants-container").addClass("hide");
        }

        console.log('addon clicked');

    });
    $(document).on("click", ".option-selector-addon .option-box", function () {

        const $this = $(this);

        $this
            .closest(".sel-wrapper")
            .find(".option-box")
            .removeClass("active");

        $this.addClass("active");

        addonSelection[$this.data("group")] = $this.data("value");

        // Update display text
        $this
            .closest(".addon-selector-group")
            .find(".initial-group")
            .text($this.data("display"));

        console.log("Current Selection", addonSelection);

        /*
        $this
        .closest(".addon-box-option")
        .addClass("active");
        */
        updateLinks();
        findAddonVariant();
        updateAddonColourAvailability();

    });

    // ----------------------------------------------------
    // Find Variant
    // ----------------------------------------------------

    function findAddonVariant() {

        //console.clear();

        let found = false;

        $(".addon-master-list li").each(function () {

            const $variant = $(this);
            const title = String($variant.data("title")).toLowerCase();


            let match = true;

            $.each(addonSelection, function (group, value) {

                value = String(value).toLowerCase();

                // ----------------------------
                // Standard / Ultra
                // ----------------------------
                /* specific to target those variants that should be standard, but has no standard in title */
                if (group == "features") {

                    if (value == "standard") {

                        if (title.includes("ultra")) {
                            match = false;
                            return false;
                        }

                        return;
                    }

                }

                var contains = title.includes(value);

                if (!contains) {
                    match = false;
                    console.log("❌ Failed");
                    return false;
                }

            });

            if (match) {


                applyAddonVariant($variant);

                found = true;


                return false;

            }


        });

        if (!found) {
            console.warn("No matching addon variant.");
        }

    }
    function updateAddonColourAvailability() {

        $(".addon-selector-group .option-box.color-box").each(function () {

            const $colour = $(this);

            const colour = String(
                $colour.data("value")
            ).toLowerCase();

            let available = false;

            $(".addon-master-list li").each(function () {

                const $variant = $(this);

                const title = String(
                    $variant.data("title")
                ).toLowerCase();

                let match = true;

                $.each(addonSelection, function (group, value) {

                    value = String(value).toLowerCase();

                    // Use the colour currently being checked
                    if (group === $colour.data("group")) {
                        value = colour;
                    }

                    // Standard / Ultra rule
                    if (group === "features") {

                        if (value === "standard") {

                            if (title.includes("ultra")) {
                                match = false;
                                return false;
                            }

                            return;
                        }
                    }

                    if (!title.includes(value)) {
                        match = false;
                        return false;
                    }

                });

                if (match) {
                    available = true;
                    return false;
                }

            });

            $colour.toggleClass(
                "disabled",
                !available
            );

        });
    }

    // ----------------------------------------------------
    // Apply Variant
    // ----------------------------------------------------

    function applyAddonVariant($variant) {

        // Active
        //$(".option-selector-addon .addon-box-option").addClass("active");

        // Image
        $(".option-selector-addon .img-wrapper img")
            .attr("src", $variant.data("image"));

        // Price
        // Price
        const price = Number(String($variant.data("price") || 0).replace(/,/g, ""));
        $(".option-selector-addon .price")
            .text("$" + price.toLocaleString());

        // Compare Price
        const compare = Number(String($variant.data("compare") || 0).replace(/,/g, ""));

        if (compare > 0) {
            $(".option-selector-addon .compare-price")
                .text("$" + compare.toLocaleString())
                .show();
        } else {
            $(".option-selector-addon .compare-price").hide();
        }

        // Selected Variant ID
        /*
        $(".selectedgroupsell")
            .text($variant.data("variant"));
        updateLinks();
        */
       // Voucher Price
        const voucher = Number($variant.data("voucher")) || 0;
        //const price = Number($variant.data("price")) || 0;

        if (voucher > 0) {

            $(".option-selector-addon .voucher-wrap")
                .removeClass("hide")
                .find(".voucher-price")
                .text("$" + (price - voucher));

        } else {

            $(".option-selector-addon .voucher-wrap").addClass("hide");

        }

       if ($(".option-selector-addon .addon-box-option").hasClass("active")) {

            $("#ProdBundle")
                .attr("data-gp2-id", $variant.data("variant"))
                .attr("data-gp2-title", $variant.data("title"))
                .attr("data-gp2-price", $variant.data("price"));
            
            $(".selectedgroupsell-addon")
                .text($variant.data("variant"));
            
            

        }else{
            $(".selectedgroupsell-addon")
                .text("");
            
        }


    }
    //findAddonVariant();
    
    $(document).ready(function () {
        $(".addon_by_variants-container").addClass("hide");
    });
    

})();
// ========================================================
// Dynamic Option Selector Addons End
// ========================================================

// ========================================================
// FIX OF SCROLL OF BUYING GUIDE
// USE SCRIPT DUE TO SNAPPING ISSUE WHEN USING THE BASIC ANCHOR LINKS
// ========================================================
function scrollToBuyingGuide() {
    const guide = document.getElementById('buying-guide');

    if (!guide) return;

    window.scrollTo({
        top: guide.offsetTop - 0,
        behavior: 'smooth'
    });
}
// ========================================================
// FIX OF SCROLL OF BUYING GUIDE End 
// ========================================================

// FIX OF SOLARIS XL NOT ADDING SPACE GREY
// weird bug since it should take data from secondgroupsell, but then now it was taking data from prodbundle.. so had to update the 3 holders with the ID
// only targets box-solaris-xl

$(document).on(
    "click",
    ".groupsell-wrap-second .box-solaris-xl .my-variant-selector .variant-item",
    function () {

        $(".selectedgroupsell-second").text($(this).data("id"));
        $("#ProdBundle")
            .attr("data-gp2-id", $(this).data("id"));

    

    }
);